<template>
  <section>
    <h4>Outgoing Commitments - Annual Amounts</h4>
    <el-table
      :class="`commitments`"
      :data="commitmentData"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="assetLiabilityType.label" label="Item"></el-table-column>
      <el-table-column prop="currentYear" align="right" header-align="center" label="Current Year">
        <template slot-scope="scope">
            <application-input isCurrency class="input-belt" :value="calculateYTD(scope.row, 'current', _.get(scope.row, 'newAsset'))" readonly></application-input>
        </template>
      </el-table-column>
      <el-table-column prop="previousYear" align="right" header-align="center" label="Previous Year">
        <template slot-scope="scope">
          <application-input isCurrency class="input-belt" :value="calculateYTD(scope.row, 'previous')" readonly></application-input>
        </template>
      </el-table-column>
      <el-table-column prop="priorYear" align="right" header-align="center" label="2 Years Prior">
        <template slot-scope="scope">
          <application-input isCurrency class="input-belt"  :value="calculateYTD(scope.row, 'prior')" readonly></application-input>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <el-form label-position="top" label-width="100px" :model="annual_commitments">
      <el-form-item label="Notes">
        <el-input type="textarea" :rows="4" placeholder="Enter notes here" v-model="annual_commitments.note"></el-input>
      </el-form-item>
    </el-form>
    <div class="row">
        <div class="col-md-12 mb-3">
            <el-table
                :data="summarytotals"
                style="width: 100%">
                <el-table-column
                label=""
                prop="label">
                    <template slot-scope="scope">
                        <strong>{{scope.row.label}}</strong>
                    </template>
                </el-table-column>
                <el-table-column
                align="right" header-align="center"
                label=""
                prop="current">
                    <template slot-scope="scope">
                        <strong>{{scope.row.current}}</strong>
                    </template>
                </el-table-column>
                <el-table-column
                align="right" header-align="center"
                label=""
                prop="previous">
                    <template slot-scope="scope">
                        <strong>{{scope.row.previous}}</strong>
                    </template>
                </el-table-column>
                <el-table-column
                align="right" header-align="center"
                label=""
                prop="prior">
                    <template slot-scope="scope">
                        <strong>{{scope.row.prior}}</strong>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "Commitments",
  components: {},
  props: {
    assetsAndLiabilities: {
      // required: true
    },
    commercialAnnualCommitments: {
      // required: true
    },
    createdAt: {
      // required: true
    }
  },
  data() {
    return {
      annual_commitments: {
        totals: [
          {
            label: "current",
            value: 0
          },
          {
            label: "previous",
            value: 0
          },
          {
            label: "prior",
            value: 0
          }
        ],
        note: ""
      },
      frequencies: [
        { name: 'Weekly', count: 52, value: 4, days: 7 },
        { name: 'Fortnightly', count: 26, value: 2, days: 14 },
        { name: 'Monthly', count: 12, value: 1, days: (this.$moment().isLeapYear() ? 366 : 365 ) / 12 },
        { name: 'Quarterly', count: 4, value: 0.333333333, days: (this.$moment().isLeapYear() ? 366 : 365 ) / 4 },
        { name: 'Annual', count: 1, value: 0.083333333, days: (this.$moment().isLeapYear() ? 366 : 365 ) }
      ]
    }
  },
  computed: {
    ...mapGetters({
        financeDetails: "summary/financeDetails",
        businessIncomeTotals: "commercial/businessIncomeTotals"
    }),
    mappedFinanceDetails(){
        let mappedData = [Object.assign(this.financeDetails, {
            assetLiabilityType: {
                label: 'This new commitment'
            },
            frequency: this.financeDetails.repaymentFrequency,
            newAsset: true
        })];
        return mappedData;
    },
    commitmentData() {
        let combined = [...this.assetsAndLiabilities.filter(row => row.ownedOutright), ...this.mappedFinanceDetails];
        this.annual_commitments.details = combined;
        return combined
    },
    summarytotals() {
        return [
            {
                label: "Surplus",
                current: this.formatCurrency(_.get(this.businessIncomeTotals, '0.value', 0) - _.get(this.annual_commitments.totals, '0.value', 0), 2),
                previous: this.formatCurrency(_.get(this.businessIncomeTotals, '1.value', 0) - _.get(this.annual_commitments.totals, '1.value', 0), 2),
                prior: this.formatCurrency(_.get(this.businessIncomeTotals, '2.value', 0) - _.get(this.annual_commitments.totals, '2.value', 0), 2)
            },
            {
                label: "Debt Service Cover Ratio",
                current: (_.get(this.businessIncomeTotals, '0.value', 0) / _.get(this.annual_commitments.totals, '0.value', 0)).toFixed(2),
                previous: (_.get(this.businessIncomeTotals, '1.value', 0) / _.get(this.annual_commitments.totals, '1.value', 0)).toFixed(2),
                prior: (_.get(this.businessIncomeTotals, '2.value', 0) / _.get(this.annual_commitments.totals, '2.value', 0)).toFixed(2)
            }
        ];
    },
    years(){
        let created_at = this.$moment(this.createdAt, "YYYY/MM/DD");
        let currentYear = created_at.format("Y")
        let previousYear = this.$moment(this.createdAt, "YYYY/MM/DD").subtract(1, "years").format("Y")
        let prior2Years = this.$moment(this.createdAt, "YYYY/MM/DD").subtract(2, "years").format("Y")


        return { current: currentYear, previous: previousYear, prior: prior2Years};
    }
  },
  watch: {
    assetsAndLiabilities: {
      handler(after, before) {
        this.$emit("update:assetsAndLiabilities", this.assetsAndLiabilities)
      },
      deep: true
    },
    "annual_commitments.totals": {
      handler(after, before) {
        this.$emit("update:commercialAnnualCommitments", this.annual_commitments);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  updated() {},
  activated() {},
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total Commitments"
          return
        }
        const values = data.map(item => {
          return {
            v: Number(item[column.property]),
            frequecy: item.frequency
          }
        })
        if (!values.every(value => isNaN(value.v))) {
          let currentColumnTotals = values.reduce((prev, curr) => {
            const value = Number(curr.v)
            if (!isNaN(value)) {
              let add = curr.v
              return prev + add
            } else {
              return prev
            }
          }, 0)
          sums[index] = this.formatCurrency(currentColumnTotals, 2)
          this.annual_commitments.totals[`${index - 1}`].value = currentColumnTotals
        } else {
          sums[index] = ""
          this.annual_commitments.totals[`${index - 1}`].value = 0
        }
      })
      return sums
    },
    calculateYTD(row, year, newAsset = false) {

      let checking = this.$moment(this.years[`${year}`] + this.$moment(row.endDate, "YYYY/MM/DD").format("/M/D"));
      let check = this.$moment(checking.format("YYYY/MM/DD")).isBetween(this.$moment(row.startDate, "YYYY/MM/DD").subtract(7, "day").format("YYYY/MM/DD"), this.$moment(row.endDate, "YYYY/MM/DD").add(7, "day").format("YYYY/MM/DD"));

      let month = checking.format("M")
      let yearBegins = (month >= 1 && month <= 6 ? this.$moment(checking, "YYYY/MM/DD").subtract(1, "years").format("Y") : this.$moment(checking, "YYYY/MM/DD").format("Y")) + "/07/01"
      let yearEnds = (month >= 1 && month <= 6 ? this.$moment(checking, "YYYY/MM/DD").format("Y") : this.$moment(checking, "YYYY/MM/DD").add(1, "years").format("Y")) + "/07/01"

      yearBegins = this.$moment(row.startDate).isAfter(yearBegins) ? row.startDate : yearBegins;
      yearEnds = this.$moment(row.endDate).isBefore(yearEnds) ? row.endDate : yearEnds;

      let result = 0;
      let fullYear = 0;

      let frequency = this.frequencies.find(i => row.frequency == i.value)
      if (_.isUndefined(frequency)) {
          frequency = this.frequencies.find(i => row.frequency == i.name)
      }

      if (check) {
          //   Calculated YTD based on the start of the finacial year and amount of payments passed.
        result = Number(
            (_.get(row, "repaymentAmount", _.get(row, "v")) * this.$moment(yearEnds).diff(yearBegins, "days")) /
            _.get(frequency, "days", 7)
        ).toFixed(2)
      }

      if (check || newAsset) {
        fullYear = Number(
            (_.get(row, "repaymentAmount", _.get(row, "v")) *  (this.$moment().isLeapYear() ? 366 : 365 )) /
            _.get(frequency, "days", 7)
        ).toFixed(2)
      }

      switch (year) {
          case 'current':
                row.currentYear = result > 0 ? result : fullYear
                return result > 0 ? result : fullYear
              break;
          case 'previous':
                row.previousYear = result
                return result;
              break;
          case 'prior':
                row.priorYear = result
                return result;
              break;
      }
    },

    formatCurrency(amount, decimals = 0) {
        let currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        })
        return currencyFormatter.format(amount)
    },
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
h4 {
    padding: 0.5rem 1rem;
    color: #2493ef!important;
    font-size: 1.1rem !important;
}
</style>
<style lang="scss">
.currency {
  input {
    text-align: right;
  }
}
.commitments {
    .el-table__footer {
        td {
            font-weight: 900 !important;
        }
    }
}

</style>
